export default function AboutUsPage() {
  return (
    <main>
      {/* Hero Section */}
      <section className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden bg-foreground-900">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900 to-foreground-900" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight font-heading">
            About Us
          </h1>
          <p className="mt-4 text-lg text-foreground-300 max-w-2xl mx-auto">
            Leading the future of mobile privacy and online security
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-white">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-6 font-heading">
                Who We Are
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4">
                Web 3.0 Soft Limited is a leading technology company specializing
                in next-generation mobile applications and digital privacy solutions.
                Founded with a vision to empower users with control over their online
                presence, we have grown to become a trusted developer of privacy-focused
                apps worldwide.
              </p>
              <p className="text-foreground-600 leading-relaxed">
                Our team of skilled software engineers and privacy specialists brings
                together extensive experience in network security, mobile development,
                and user-centric design. We are committed to creating tools that are
                powerful yet simple, giving everyone the ability to browse freely and
                securely.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-6 font-heading">
                Our Mission
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                To empower individuals with cutting-edge privacy tools that provide
                comprehensive online protection without compromising speed or
                user experience. We believe that everyone deserves access to a secure,
                private, and ad-free internet.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="bg-background-50 p-6 rounded-xl border border-background-200 text-center">
                <div className="w-14 h-14 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-foreground-900 mb-2">Excellence</h3>
                <p className="text-foreground-600 text-sm">Committed to delivering the highest quality privacy solutions</p>
              </div>
              <div className="bg-background-50 p-6 rounded-xl border border-background-200 text-center">
                <div className="w-14 h-14 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-foreground-900 mb-2">Innovation</h3>
                <p className="text-foreground-600 text-sm">Pioneering new technologies to stay ahead of online threats</p>
              </div>
              <div className="bg-background-50 p-6 rounded-xl border border-background-200 text-center">
                <div className="w-14 h-14 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-foreground-900 mb-2">Trust</h3>
                <p className="text-foreground-600 text-sm">Building lasting relationships through reliable protection</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}